const HOME = '/'
const LOGIN = '/login'
const SIGNUP = '/register'

export default {
    HOME,
    LOGIN,
    SIGNUP
}